

















































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";
import info from "../../utils/info";
import Divider from "../../components/common/Divider.vue";

@Component({
  components: {
    Divider,
  },
})
export default class AdminSideBar extends Vue {
  privilegeName = constants.PRIVILEGE_NAME;
  userEmail = info.getEmail();

  private checkFullPrivileges(name: string): boolean {
    return privileges.checkFullPrivileges(name);
  }

  private serCurrentOption(path: string): string {
    if (path == this.$route.path) {
      return "blue";
    } else {
      return "white";
    }
  }

  private signOut(): void {
    localStorage.removeItem("info");
    this.$router.push("/admin/sign-in");
  }

  private goToOption(url: string): void {
    this.$router.currentRoute.path != url ? this.$router.push(url) : false;
  }
}
